import { ClientOnly } from 'remix-utils/client-only';

interface ClientSideFormProps {
  name?: string;
  visitToken?: string;
  redirectUrl?: string;
  fallbackPath?: string;
  webhookUrl?: string;
}

const ClientSideInputs = ({ name, visitToken, redirectUrl, fallbackPath, webhookUrl }: ClientSideFormProps) => {
  return (
    <ClientOnly fallback={null}>
      {() => (
        <>
          {name && <input hidden name="form_name" defaultValue={name} />}
          {/* honeypot field */}
          <input hidden name="nickname" />
          {visitToken && <input hidden name="visit_token" value={visitToken || ''} onChange={() => null} />}
          {fallbackPath && <input hidden name="fallback_path" defaultValue={fallbackPath} />}
          {redirectUrl && <input hidden name="redirect_path" defaultValue={redirectUrl} />}
          {webhookUrl && <input hidden name="webhook_url" defaultValue={webhookUrl} />}
          <input hidden name="is_js_enabled" defaultValue="true" />
        </>
      )}
    </ClientOnly>
  );
};

export default ClientSideInputs;
